import type { SVGProps } from "react";
export default function SvgVideo(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-video-icon lucide-video"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
			<rect width={14} height={12} x={2} y={6} rx={2} />
		</svg>
	);
}
